module.exports = __webpack_public_path__ + "img/japan.24a1cbc.webp";